import { isEnabledLocale, LOCALE_COOKIE, type Locale } from './config'
import { negotiateLocale } from './negotiate'

/**
 * In the browser, the reader's locale as `getUserLocale` resolves it on the
 * server: the language cookie, else the browser's languages.
 */
export function readerLocale(): Locale {
  const cookie = document.cookie
    .split('; ')
    .find((pair) => pair.startsWith(`${LOCALE_COOKIE}=`))
    ?.slice(LOCALE_COOKIE.length + 1)
  return isEnabledLocale(cookie)
    ? cookie
    : negotiateLocale(navigator.languages.join(','))
}
